export const init = (survey: any) => {

  const resizeMe = (img) => {
    const canvas = document.createElement('canvas');

    const maxWidth = 600;
    const maxHeight = 600;

    let width = img.width;
    let height = img.height;

    // calculate the width and height, constraining the proportions
    if (width > height) {
      if (width > maxWidth) {
        //height *= maxWidth / width;
        height = Math.round(height *= maxWidth / width);
        width = maxWidth;
      }
    } else {
      if (height > maxHeight) {
        //width *= maxHeight / height;
        width = Math.round(width *= maxHeight / height);
        height = maxHeight;
      }
    }

    // resize the canvas and draw the image data into it
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, width, height);
    return canvas.toDataURL('image/jpeg',1.0); // get the data from canvas as 70% JPG (can be also PNG, etc.)
  };

  const getFileReader = () => {
    const fileReader = new FileReader();
    const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
    return zoneOriginalInstance || fileReader;
  };

  const photoWidget = {
    name: 'photo',
    title: 'Photo',
    iconName: '',
    widgetIsLoaded: () => true,
    isFit: (question) => question.getType() === 'photo',

    activatedByChanged: (activatedBy) => {
      survey.JsonObject.metaData.addClass('photo', [], null, 'text');
      survey.JsonObject.metaData.addProperties('photo', [
        { name: 'addButtonText', default: 'Add' },
        { name: 'clearButtonText', default: 'Clear' },
        { name: 'showGalleryOption:boolean', default: 1 },
        { name: 'galleryMaxWidth', default: 1000 },
        { name: 'galleryMaxHeight', default: 1000 },
      ]);
    },
    isDefaultRender: false,
    htmlTemplate:
      `<div>
        <input type='file' accept='image/png, image/jpeg' />
        <input type="button" style="
          padding: 0.5em 2.786em 0.6em;font-weight: bold;border-radius: 1.214em;border: none; background-color: #2196f3;color: white;"
          value="Gallery" />
        <input type="button" style="
          padding: 0.5em 2.786em 0.6em;font-weight: bold;border-radius: 1.214em;border: none; background-color: #f44336;color: white;"
          value="Clear" />
        <br>
        <img style='width:200px' />
      </div>`,

    afterRender: (question, el) => {

      const inputs = el.getElementsByTagName('input');
      const fileInput: any = inputs[0];
      const galleryInput = inputs[1];
      const clearButton = inputs[2];

      const img: any = el.getElementsByTagName('img')[0];
      clearButton.innerText = question.clearButtonText;

      img.style.display = 'none';
      fileInput.style.display = 'none';
      clearButton.style.display = 'none';

      galleryInput.onclick = async () => {
        fileInput.click();
      };


      clearButton.onclick = () => {
        galleryInput.style.display = 'block';

        img.style.display = 'none';
        clearButton.style.display = 'none';
        img.src = '';
        question.value = '';
      };

      fileInput.onchange = () => {
        const fileName = fileInput.files[0];
        if (fileInput.files.length === 0) {
          return;
        }

        if (!( /image/i ).test( fileName.type)){
          alert( 'File '+ fileName +' is not an image.' );
          return false;
        }
        const reader = getFileReader();//new FileReader();
        reader.onloadend = (evt: any) => {
          const imgBlob = new Blob([evt.target.result], { type: fileName.type});
          const readerBlob = getFileReader();//new FileReader();
          readerBlob.onloadend = () => {
            galleryInput.style.display = 'none';
            clearButton.style.display = 'block';
            img.style.display = 'block';

            img.onload = async () => {
              img.onload = null;
              // have to wait till it's loaded
              const resized = resizeMe(img); // send it to canvas
              question.value = {img: resized, path: resized};
            };
            img.src = readerBlob.result;
          };
          readerBlob.readAsDataURL(imgBlob);

        };
        reader.readAsArrayBuffer(fileName);
      };

      const onValueChangedCallback = () => {
        if (typeof(question.value) == 'undefined') {
          return;
        }

        const jsonObj = question.value;
        if(jsonObj && (jsonObj.img || jsonObj.path)) {
          galleryInput.style.display = 'none';
          clearButton.style.display = 'block';
          img.style.display = 'block';
          img.src = jsonObj.img;
        } else {
          galleryInput.style.display = 'block';
          clearButton.style.display = 'none';
          img.style.display = 'none';
          img.src = '';
        }
      };
      const onReadOnlyChangedCallback = () => {

      };
      question.readOnlyChangedCallback = onReadOnlyChangedCallback;
      question.valueChangedCallback = onValueChangedCallback;
      onValueChangedCallback();
      onReadOnlyChangedCallback();

    },

    willUnmount: (question, el) => {
    },
  };
  survey.CustomWidgetCollection.Instance.addCustomWidget(photoWidget, 'customtype');
};
